import { Box, Skeleton } from '@mui/material';

const TreeSkeleton = () => {
  return (
    <Box
      sx={{
        width: '40%',
        height: '100%',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {new Array(10).fill(null).map((_, index) => (
        <Skeleton key={index} variant="rectangular" height={32}></Skeleton>
      ))}
    </Box>
  );
};

export default TreeSkeleton;
